var exports = {
  "sB": "x4ddf2309--14841f--village_list",
  "_V": "x4ddf2309--14841f--village_list_page",
  "ib": "x4ddf2309--14841f--village_list-top",
  "RC": "x4ddf2309--14841f--preloader",
  "TD": "x4ddf2309--14841f--preload_overlay",
  "vK": "x4ddf2309--14841f--banner",
  "z6": "x4ddf2309--14841f--village_list-heading",
  "z": "x4ddf2309--14841f--summary",
  "mp": "x4ddf2309--14841f--feedback",
  "_K": "x4ddf2309--14841f--seo_text",
};

module.exports = exports;
